var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timetable-wrap"},[_c('div',{staticClass:"crumbs"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_c('i',{staticClass:"el-icon-fa fa-table"}),_vm._v(" 课表查询 ")])],1)],1),_c('div',{staticClass:"container"},[_c('time-table',{ref:"timeTable"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }